<script>
import PlansCustomer from '@/views/Manage/Plans/PlansCustomer.vue';
import PlansPartner from '@/views/Manage/Plans/PlansPartner.vue';

export default {
  name: 'Plans',
  components: { PlansCustomer, PlansPartner },

  data() {
    return {
      activeTab: 0,
    };
  },
};
</script>

<template>
  <div class="enhancify">
    <h1>Plans</h1>
    <b-tabs class="modern-tab" v-model="activeTab">
      <b-tab-item label="Customer">
        <keep-alive>
          <PlansCustomer v-if="activeTab === 0"/>
        </keep-alive>
      </b-tab-item>
      <b-tab-item label= "Partner">
        <keep-alive>
          <PlansPartner v-if="activeTab === 1"/>
        </keep-alive>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<style scoped lang="stylus">

</style>
